window.sq = window.sq || {};
window.sq.onItemComplete = function (el, item, variants) {
  if (item.variants && item.variants.length > 1) {
    let atc = el.querySelector('.sq-add-to-cart');
    let view = el.querySelector('.sparq-cart-icon');
    if (atc) {
      atc.style.display = "none";
    }

    if (view) {
      view.style.display = "block";
    }
  }

  if (item.variants && item.variants.length < 2) {
    let view = el.querySelector('.sparq-cart-icon');
    let atc = el.querySelector('.sq-add-to-cart');
    if (atc) {
      atc.style.display = "block";
    }
    if (view) {
      view.style.display = "none";
    }
  }

}

window.sq.onCartAdded = function () {
  jQuery.ajax({
    type: "GET",
    url: '/',
    dataType: 'HTML',
    async: false,
    success: function (response) {
      // find the element in the response and then update the document's element
      let cartCountElements = $(response).find('.cart-item-count-header--quantity');
      console.log("cart updated");
      if (cartCountElements && cartCountElements.length) {
        let count = cartCountElements[0].innerHTML;
        if (count) {
          Array.from($(document).find('.cart-item-count-header--quantity')).forEach(x => { x.innerHTML = `(${count})` })
        }
      }
      let cartDrawerElement = $(response).find('#CartContainer');
      console.log("drawer updated");
      if (cartDrawerElement && cartDrawerElement.length) {
        let count1 = cartDrawerElement[0].innerHTML;
        if (count1) {
          console.log(count1);
          Array.from($(document).find('#CartContainer')).forEach(x => { x.innerHTML = count1; })
        }
      }
      setTimeout(() => {
        let atc = document.querySelector('.cart-item-count-header--quantity');
        if (atc) {
          atc.click();
        }
      }, 3000);
    }
  })
}

window.sq.onComplete = function (el) {
  $('select option:contains("Relevance")').remove();
}